import { Skeleton } from '@mui/material';

export const NotifyAvailabilityIframe: React.FC<{ src?: string }> = ({ src }) => {
	if (!src) {
		return <Skeleton variant="rectangular" width="100%" height={350} />;
	}

	return (
		<iframe
			src={src}
			width="100%"
			height="100%"
			style={{ border: 'none', maxWidth: '586px' }}
			allowFullScreen
		></iframe>
	);
};
